<script setup>
import SiteLogo from 'components/SiteLogo.vue';
import UserMenuToggle from 'components/UserMenuToggle.vue';
import { useBreakpoint } from 'composables/breakpoint';
import { useQuasar } from 'quasar';
import AppRoute from 'src/router/app-route';
import { Route } from 'src/router/routes';
import { useAuthStore } from 'stores/auth-store';
import { computed } from 'vue';

const $q = useQuasar();
const authStore = useAuthStore();
const breakpoint = useBreakpoint();

const navLinks = [
    { text: 'Job Search', route: AppRoute.build(Route.SearchResultsPage) },
    { text: 'Post a Job', route: AppRoute.build(Route.JobManagerWizardPage) },
    { text: 'My Profile', route: AppRoute.build(Route.ProfileManagerPage) }
];

const logoWidth = computed(() => {
    if (!breakpoint.lt.md) {
        return '243px';
    }
    return '165px';
});

const logoHeight = computed(() => {
    if (!breakpoint.lt.md) {
        return '40px';
    }
    return '27px';
})
</script>

<template>
    <q-header :height-hint="70" class="flex" reveal unelevated>
        <q-toolbar class="container-md q-px-md">
            <div class="flex row q-gutter-x-lg">
                <div class="logo-section flex row items-center col-auto">
                    <SiteLogo :width="logoWidth" :height="logoHeight" :inverted="$q.dark.isActive"/>
                </div>
                <nav v-if="!breakpoint.lt.md" class="nav-section flex row col items-center justify-end">
                    <router-link v-if="!breakpoint.lt.md" v-for="link in navLinks" :key="link" :to="link.route">{{ link.text }}</router-link>
                </nav>
                <div class="button-section flex row q-gutter-x-sm q-ml-auto q-mr-none items-center">
                    <UserMenuToggle title="Toggle user menu" class="cursor-pointer"/>
                    <q-btn
                        v-if="!authStore.isUserAuthenticated"
                        :to="AppRoute.build(Route.LoginPage)"
                        icon="sym_r_login"
                        color="primary"
                        padding="6px"
                        aria-label="Log in"
                        flat
                    />
                </div>
            </div>
        </q-toolbar>
    </q-header>
</template>

<style lang="scss" scoped>
.q-header {
    background: rgba($white, 0.8);
    backdrop-filter: blur(5px);
    border-bottom: 1px solid rgba($grey-3, 0.6);
    height: 70px;

    .body--dark & {
        background: rgba($dark, 0.9);
    }
}

.logo-section {
    height: auto;
}

.q-toolbar,
.q-toolbar > div {
    flex: 1;
}

.nav-section > * {
    margin-left: 16px;
    margin-right: 16px;
}
</style>
